import { useQuery } from '@tanstack/react-query';

import { HomepageMetricsParams, getHomepageMetrics } from '~/services/ExperiencesService';

import { experiencesQueryKeys } from './experiencesQueryKeys';

export function useHomepageMetrics(params: HomepageMetricsParams, enabled = true) {
  return useQuery({
    queryKey: experiencesQueryKeys.homepageMetrics(params),
    queryFn: ({ signal }) => getHomepageMetrics(params, signal),
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
